export class BaseModel {
	createdBy?: string;
	createdDate?: string;
	modifiedBy?: string;
	modifiedDate?: string;
}
